/**
     * @ngdoc directive
     * @name directives.$focus
     *
     * @description
     * Listens for a `focus` event and focuses its element
     * if the event is for it
     */
angular.module('directives')
    .directive('focus', () => (scope, elem, attrs) => {

        scope.$on('focus', (e, name) => {

            if (attrs.focus === name) {

                elem[0].focus();

            }

        });

    });



// WEBPACK FOOTER //
// ./scripts/common/directives/focus.js